import { Injectable, signal } from '@angular/core';

import { CorrectScoreHeaderButtonTabs } from '@frontend/sports/betting-offer/feature/model';
import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';

@Injectable()
export class CorrectScoreOptionGroupToggleViewService {
    currentViewId = signal<string>(
        this.eventDetailsConfig.enableCorrectScoreOptionGroupToggle
            ? CorrectScoreHeaderButtonTabs.CorrectScoreCompactView
            : CorrectScoreHeaderButtonTabs.CorrectScoreRegularView,
    );

    constructor(private eventDetailsConfig: EventDetailsConfig) {}

    setCorrectScoreView(id: string): void {
        this.currentViewId.set(id);
    }
}
